import { useCallback, useMemo } from 'react'
import { useGlobalHomesAndVillasSearch } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHomesAndVillasSearch'
import useSearchVerticalLabels from 'hooks/GlobalSearch/useSearchVerticalLabels'
import HomesAndVillasTabContent from '../Components/Mobile/TabContents/HomesAndVillasTabContent'
import useGlobalSearchVerticalTabBooking from './useGlobalSearchVerticalTabBooking'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import useQueryParams from 'hooks/useQueryParams'
import LineHomeAltIcon from 'LuxKit/Icons/line/LineHomeAltIcon'

function useGlobalSearchVerticalTabHomesAndVillas(): App.GlobalSearchVerticalTabV2 {
  const queryParams = useQueryParams()
  const verticalLabels = useSearchVerticalLabels()

  const {
    globalHomesAndVillasSearchDispatch,
    globalHomesAndVillasSearchState,
  } = useGlobalHomesAndVillasSearch(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  const {
    onSearch,
    context,
    updateSearchSessionId,
  } = useGlobalSearchVerticalTabBooking({
    globalSearchDispatch: globalHomesAndVillasSearchDispatch,
    globalSearchState: globalHomesAndVillasSearchState,
    baseSearchPath: '/search/homes-and-villas',
    baseSearchMapPath: '/search/homes-and-villas/map',
  })

  const onRequestSearch = useCallback(() => {
    return onSearch()
  }, [onSearch])

  return useMemo((): App.GlobalSearchVerticalTabV2 => ({
    label: verticalLabels['homes-and-villas'],
    key: 'homes-and-villas',
    context,
    onSearch: onRequestSearch,
    ContentComponent: HomesAndVillasTabContent,
    Icon: LineHomeAltIcon,
    updateSearchSessionId,
  }), [context, onRequestSearch, updateSearchSessionId, verticalLabels])
}

export default useGlobalSearchVerticalTabHomesAndVillas
